import { defineMessages } from 'react-intl-next';

export const spotlightMessages = defineMessages({
	spotlightHeading: {
		id: 'export-issues-flyout-spotlight-tour.spotlight.heading',
		defaultMessage: 'Export options have moved',
		description: 'Heading for the export issues flyout spotlight',
	},
	spotlightBody: {
		id: 'export-issues-flyout-spotlight-tour.spotlight.body',
		defaultMessage:
			'Export your work items in the format you need, right from the more actions menu.',
		description: 'Body for the export issues flyout spotlight',
	},
	spotlightOkButton: {
		id: 'export-issues-flyout-spotlight-tour.spotlight.okButton',
		defaultMessage: 'OK',
		description: 'OK button for the export issues flyout spotlight',
	},
});
